function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});
  observer.observe(options.element);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  summary.addEventListener('click', (event) => event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')));
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  elements = elements.filter((element) => element.offsetParent != null);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = () => document.removeEventListener('keydown', trapFocusHandlers.keydown);
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
  const opts = Object.defineProperty({}, 'passive', {
    get: () => {
      ThemeSupportsPassive = true;
    }
  });
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', (event) => mouseClick = true);

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*'));
  document.querySelectorAll('.js-vimeo').forEach((video) => video.contentWindow.postMessage('{"method":"pause"}', '*'));
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

const subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) subscribers[eventName].forEach((callback) => callback(data));
}

function convertBreakpoint(breakpoint) {
  let screen;
  switch (breakpoint) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 989px)';
      break;
    case 'large':
      screen = '(min-width: 990px)';
      break;
  }

  return screen
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.','');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.shopMoney.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    number = number.toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class AlertModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(duration = 500) {
    this.classList.add('active');
    setTimeout(() => {
      this.classList.remove('active');
    }, duration);
  }
}

customElements.define('alert-modal', AlertModal);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('[data-variant-image-src]');
    [...this.swatches].forEach((swatch) => swatch.addEventListener('click', this.swapImage.bind(this)));
  }

  swapImage(event) {
    event.preventDefault();
    const mediaFeatured = event.currentTarget.closest('.card').querySelector('img');
    if (!mediaFeatured) return;
    mediaFeatured.setAttribute('src', event.currentTarget.dataset.variantImageSrc);
    mediaFeatured.setAttribute('srcset', event.currentTarget.dataset.variantImageSrcset);
    [...this.swatches].forEach((swatch) => swatch.classList.toggle('active', swatch.contains(event.target)));
  }
}

customElements.define('color-swatch', ColorSwatch);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.date = new Date(`${this.dataset.month}/${this.dataset.day}/${this.dataset.year} ${this.dataset.hour}:${this.dataset.minute}:00`);
    this.template = this.querySelector('template').content.firstElementChild.innerHTML;
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.calculate();
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  calculate() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.complete();
      return;
    }

    let content = this.template;

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;
    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
    const days_text = days === 1 ?  window.countdownTimer.day :  window.countdownTimer.days;
    const hours_text = hours === 1 ?  window.countdownTimer.hour :  window.countdownTimer.hours;
    const mins_text = mins === 1 ?  window.countdownTimer.minute :  window.countdownTimer.minutes;
    const secs_text = secs === 1 ?  window.countdownTimer.second :  window.countdownTimer.seconds;

    content = content.replaceAll('[days]', days);
    content = content.replaceAll('[hours]', hours);
    content = content.replaceAll('[mins]', mins);
    content = content.replaceAll('[secs]', secs);
    content = content.replaceAll('[days_text]', days_text);
    content = content.replaceAll('[hours_text]', hours_text);
    content = content.replaceAll('[mins_text]', mins_text);
    content = content.replaceAll('[secs_text]', secs_text);

    const html = new DOMParser().parseFromString(content, 'text/html');
    this.innerHTML = html.body.innerHTML;
  }

  complete() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.innerHTML = this.getAttribute('data-countdown-timer-ended-text');
  }
}
customElements.define('countdown-timer', CountdownTimer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    if(this.hasAttribute('data-auto-load')) this.loadContent(false);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      // force autoplay for safari
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) deferredElement.play();
      // update video for swiper
      if(this.closest('theme-swiper')) this.closest('theme-swiper').updateVideos();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class DeferredMediaButton extends HTMLElement {
  constructor() {
    super();

    const deferredMedia = document.querySelector(`[data-media-id="${this.dataset.videoId}"]`);
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      deferredMedia.loadContent(true)
    });
  }
}

customElements.define('deferred-media-button', DeferredMediaButton);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setPseudoclass();
    this.addEventListener('focusin', this.openDropdown.bind(this));
    this.addEventListener('focusout', this.closeDropdown.bind(this));
  }

  openDropdown() {
    this.classList.add('active');
  }

  closeDropdown() {
    this.classList.remove('active');
  }

  setPseudoclass() {
    if (!this.header) return;
    if(this.header.firstElementChild.classList.contains('header--top-center') || this.header.firstElementChild.classList.contains('header--top-left')) {
      this.style.setProperty('--p-header-menu', `var(--padding-bottom)`);
    } else {
      this.style.setProperty('--p-header-menu', `${Math.floor((this.header.offsetHeight - this.offsetHeight)/2)}px`);
    }
  }
}

customElements.define('header-menu', HeaderMenu);

class HeaderSubMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('focusin', this.openDropdown.bind(this));
    this.addEventListener('focusout', this.closeDropdown.bind(this));
  }

  openDropdown() {
    this.classList.add('active');
  }

  closeDropdown() {
    this.classList.remove('active');
  }
}

customElements.define('header-submenu', HeaderSubMenu);

class LoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  enableLoading() {
    this.classList.remove('hidden');
    this.querySelector('.loading-overlay').setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.add('hidden');
    this.querySelector('.loading-overlay').setAttribute('aria-hidden', true);
  }
}

customElements.define('loading-overlay', LoadingOverlay);

class MapTemplate extends HTMLElement {
  constructor() {
    super();

    this.frame = this.querySelector('iframe');
  }

  init() {
    this.frame.addEventListener('load', function() {
      this.dispatchEvent(new CustomEvent('loadingEnd', { detail: { element: this.frame, parent: this }}));

      this.setAttribute('loaded', true);
    }.bind(this))
  }

  execute() {
    this.setIframeSrc();
  }

  setIframeSrc() {
    this.frame.src = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g,"")}&ie=UTF8&&output=embed`;
    this.frame.removeAttribute('srcdoc');
  }

  loadIframeSrc() {
    new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          this.dispatchEvent(new CustomEvent('loadingStart', { detail: { element: this.frame, parent: this }}));

          this.execute();
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -100px 0px" }).observe(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    oldValue !== newValue && (Shopify.designMode ? this.execute() : this.loadIframeSrc())
  }

  connectedCallback() {
    this.init();
  }

  static get observedAttributes() {
    return ['data-zoom', 'data-type', 'data-location']
  }

  get dataZoom() {
    return this.getAttribute('data-zoom')
  }

  get dataType() {
    return this.getAttribute('data-type')
  }

  get dataLocation() {
    return this.getAttribute('data-location')
  }

  set dataZoom(zoom) {
    this.setAttribute('data-zoom', zoom);
  }

  set dataType(type) {
    this.setAttribute('data-type', type);
  }

  set dataLocation(location) {
    this.setAttribute('data-location', location);
  }
}

customElements.define('map-template', MapTemplate);

class MenuDetails extends HTMLElement {
  constructor() {
    super();

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  get parent() {
    return this.closest('[data-menu-details-parent]');
  }

  get details() {
    return this.querySelector('details');
  }

  get summary() {
    return this.querySelector('summary');
  }

  get button() {
    return this.querySelector('button');
  }

  onSummaryClick() {
    setTimeout(() => {
      this.parent.classList.add('active');
      this.details.classList.add('active');
      this.summary.setAttribute('aria-expanded', true);
    }, 100);
  }

  onButtonClick() {
    this.parent.classList.remove('active');
    this.details.classList.remove('active');
    this.summary.setAttribute('aria-expanded', false);
    this.closeAnimation();
  }

  closeAnimation() {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.details.removeAttribute('open');
      }
    }
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-details', MenuDetails);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.delay = 0;
    this.animate = false;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
  }

  get gesture() {
    return this.querySelector('theme-gesturer');
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.hide.bind(this));
    if (this.gesture) this.initGesture();
  }

  initGesture(){
    this.gestureConfig = {
      animationFrame: null,
      moveY: 0,
      maxGestureDistance: 0,
      endPoint: 0,
      layerHeight: null
    };

    this.gestureWrap = this.gesture.parentElement;

    setTimeout(() => {
      this.gesture.on('panstart', this.onPanStart.bind(this));
      this.gesture.on('panmove', this.onPanMove.bind(this));
      this.gesture.on('panend', this.onPanEnd.bind(this));
    }, 75);
  }

  resetGesture() {
    this.gestureWrap.style.transform = '';
    this.gestureWrap.style.transition = '';
    this.overlay.style.opacity = '';
    this.overlay.style.transition = '';
  }

  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const popup = this.querySelector('.template-popup');
    if (popup) popup.loadContent();

    setTimeout(() => {
      this.classList.add('animate', 'active');
      setScrollbarWidth();
      document.body.classList.add('modal-show', 'o-hidden');
    }, this.delay);

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    if (this.gesture) this.resetGesture();
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'o-hidden');
    removeTrapFocus(this.activeElement);
    window.pauseAllMedia();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onPanStart() {
    this.removeTransition(this.gestureWrap, 'transform');

    if (this.classList.contains('active')) {
      if (this.gestureConfig.layerHeight === null) this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;
      this.gestureConfig.maxGestureDistance = this.gestureConfig.layerHeight - 50;
      this.gestureConfig.endPoint = this.gestureConfig.layerHeight * 0.3;
    }
  }

  onPanMove() {
    if (this.gestureConfig.animationFrame) return;

    this.gestureConfig.animationFrame = window.requestAnimationFrame(() => {
      const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
      const invlerp = (x, y, a) => clamp((a - x) / (y - x));

      // Give an indication of whether we've passed the swiping threshold.
      this.gestureWrap.style.transition = 'transform .1s linear';
      this.overlay.style.transition = 'opacity .1s linear';

      if (this.classList.contains('active')) {
        if (this.gestureConfig.layerHeight === null) this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;

        this.gestureConfig.moveY = this.gesture.touchMoveY;
        this.gestureConfig.maxGestureDistance = this.gestureConfig.layerHeight - 50;

        if (this.gestureConfig.moveY >= 0) {
          this.gestureWrap.style.transform = `translateY(${Math.min(
            this.gestureConfig.moveY,
            this.gestureConfig.maxGestureDistance
          )}px)`;

          this.overlay.style.opacity = invlerp(this.gestureConfig.layerHeight, 0, this.gestureConfig.moveY);
        } else {
          this.gestureWrap.style.transform = 'translateY(0)';
          this.gestureWrap.style.transition = '';
          this.overlay.style.opacity = '1';
        }
      }

      this.gestureConfig.animationFrame = null;
    });
  }

  onPanEnd() {
    this.gestureConfig.animationFrame === null || window.cancelAnimationFrame(this.gestureConfig.animationFrame);
    this.gestureConfig.animationFrame = null;
    this.gestureWrap.style.transition = 'transform .1s linear';

    if (this.gestureConfig.layerHeight === null) {
      this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;
    }

    this.gestureConfig.endPoint = this.gestureConfig.layerHeight * 0.3;

    if (this.classList.contains('active')) {
      this.gestureConfig.moveY = this.gesture.touchMoveY;

      if (this.gestureConfig.moveY < this.gestureConfig.endPoint) {
        this.gestureWrap.style.transform = 'translateY(0)';
      } else {
        this.gestureWrap.style.transform = `translateY(${this.gestureConfig.layerHeight}px)`;

        this.gestureWrap.addEventListener(this.whichTransitionEvent(), () => this.hide(), { once: true });
      }
    }
  }

  removeTransition(node, transition) {
    const match = node.style.transition.match(new RegExp('(?:^|,)\\s*' + transition + '(?:$|\\s|,)[^,]*', 'i'));
    if (match) {
      const transitionArray = node.style.transition.split('');
      transitionArray.splice(match.index, match[0].length);
      node.style.transition = transitionArray.join('');
    }
  }

  whichTransitionEvent() {
    let t;
    const el = document.createElement('fakeelement');
    const transitions = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      MSTransition: 'msTransitionEnd',
      OTransition: 'oTransitionEnd',
      transition: 'transitionEnd',
    };

    for (t in transitions) {
      if (el.style[t] !== undefined) return transitions[t];
    }
  }
}

customElements.define('modal-dialog', ModalDialog);

class SmallModalDialog extends ModalDialog {
  constructor() {
    super();

    this.delay = 0;
    this.animate = false;
    this.moved = this.hasAttribute('data-moved');
  }
}

customElements.define('small-modal-dialog', SmallModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.searchButton = this.querySelector('button[type="submit"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => { this.onChange(event) }, 300).bind(this));
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
      this.searchButton.classList.add('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
      this.searchButton.classList.remove('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class SearchContainer extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) this.keepInSync('', this.input);
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    this.scrollIntoView({ behavior: 'smooth' })
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) input.value = value;
    });
  }
}

customElements.define('search-container', SearchContainer);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) nextElementToFocus.querySelector('input').focus();
    });
  }

  expandShowMore(event) {
    const _target = event.currentTarget;
    const _parent = _target.closest('[id^="Show-More-"]').closest('.parent-display');
    _target.classList.toggle('show');
    if(_target.classList.contains('show')) {
      _target.querySelector('span').innerText = _target.dataset.showLessText;
    } else {
      _target.querySelector('span').innerText = _target.dataset.showMoreText;
    }
    _parent.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

class SideDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  get gesture() {
    return this.querySelector('theme-gesturer');
  }

  get overlay() {
    return this.querySelector('[id^="Drawer-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
    if (this.gesture) this.initGesture();
  }

  initGesture(){
    this.gestureConfig = {
      animationFrame: null,
      moveY: 0,
      maxGestureDistance: 0,
      endPoint: 0,
      layerHeight: null
    };

    this.gestureWrap = this.gesture.parentElement;

    setTimeout(() => {
      this.gesture.on('panstart', this.onPanStart.bind(this));
      this.gesture.on('panmove', this.onPanMove.bind(this));
      this.gesture.on('panend', this.onPanEnd.bind(this));
    }, 75);
  }

  resetGesture() {
    this.gestureWrap.style.transform = '';
    this.gestureWrap.style.transition = '';
    this.overlay.style.opacity = '';
    this.overlay.style.transition = '';
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      setScrollbarWidth();
    }, { once: true });
    document.body.classList.add('drawer-show', 'o-hidden');
  }

  close() {
    if (this.gesture) this.resetGesture();
    this.classList.remove('animate', 'active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('drawer-show', 'o-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onPanStart() {
    this.removeTransition(this.gestureWrap, 'transform');

    if (this.classList.contains('active')) {
      if (this.gestureConfig.layerHeight === null) this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;
      this.gestureConfig.maxGestureDistance = this.gestureConfig.layerHeight - 50;
      this.gestureConfig.endPoint = this.gestureConfig.layerHeight * 0.3;
    }
  }

  onPanMove() {
    if (this.gestureConfig.animationFrame) return;

    this.gestureConfig.animationFrame = window.requestAnimationFrame(() => {
      const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
      const invlerp = (x, y, a) => clamp((a - x) / (y - x));

      // Give an indication of whether we've passed the swiping threshold.
      this.gestureWrap.style.transition = 'transform .1s linear';
      this.overlay.style.transition = 'opacity .1s linear';

      if (this.classList.contains('active')) {
        if (this.gestureConfig.layerHeight === null) this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;

        this.gestureConfig.moveY = this.gesture.touchMoveY;
        this.gestureConfig.maxGestureDistance = this.gestureConfig.layerHeight - 50;

        if (this.gestureConfig.moveY >= 0) {
          this.gestureWrap.style.transform = `translateY(${Math.min(
            this.gestureConfig.moveY,
            this.gestureConfig.maxGestureDistance
          )}px)`;

          this.overlay.style.opacity = invlerp(this.gestureConfig.layerHeight, 0, this.gestureConfig.moveY);
        } else {
          this.gestureWrap.style.transform = 'translateY(0)';
          this.gestureWrap.style.transition = '';
          this.overlay.style.opacity = '1';
        }
      }

      this.gestureConfig.animationFrame = null;
    });
  }

  onPanEnd() {
    this.gestureConfig.animationFrame === null || window.cancelAnimationFrame(this.gestureConfig.animationFrame);
    this.gestureConfig.animationFrame = null;
    this.gestureWrap.style.transition = 'transform .1s linear';

    if (this.gestureConfig.layerHeight === null) {
      this.gestureConfig.layerHeight = this.gestureWrap.getBoundingClientRect().height;
    }

    this.gestureConfig.endPoint = this.gestureConfig.layerHeight * 0.3;

    if (this.classList.contains('active')) {
      this.gestureConfig.moveY = this.gesture.touchMoveY;

      if (this.gestureConfig.moveY < this.gestureConfig.endPoint) {
        this.gestureWrap.style.transform = 'translateY(0)';
      } else {
        this.gestureWrap.style.transform = `translateY(${this.gestureConfig.layerHeight}px)`;

        this.gestureWrap.addEventListener(this.whichTransitionEvent(), () => this.close(), { once: true });
      }
    }
  }

  removeTransition(node, transition) {
    const match = node.style.transition.match(new RegExp('(?:^|,)\\s*' + transition + '(?:$|\\s|,)[^,]*', 'i'));
    if (match) {
      const transitionArray = node.style.transition.split('');
      transitionArray.splice(match.index, match[0].length);
      node.style.transition = transitionArray.join('');
    }
  }

  whichTransitionEvent() {
    let t;
    const el = document.createElement('fakeelement');
    const transitions = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      MSTransition: 'msTransitionEnd',
      OTransition: 'oTransitionEnd',
      transition: 'transitionEnd',
    };

    for (t in transitions) {
      if (el.style[t] !== undefined) return transitions[t];
    }
  }
}

customElements.define('side-drawer', SideDrawer);

class SideDrawerTab extends HTMLElement {
  constructor() {
    super();

    this.buttons = Array.from(this.querySelectorAll('button'));
    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();

    this.buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('active');
      document.getElementById(button.getAttribute('data-tab'))?.removeAttribute('open');
    });

    const _targetTab = document.getElementById(event.currentTarget.getAttribute('data-tab'));
    event.currentTarget.setAttribute('aria-expanded', 'true');
    event.currentTarget.classList.add('active');
    _targetTab?.setAttribute('open', '');
  }

  reset() {
    const firstTab = this.buttons[0];
    firstTab.dispatchEvent(new Event('click'));
  }
}

customElements.define('side-drawer-tab', SideDrawerTab);

class SpinningText extends HTMLElement {
  constructor() {
    super();

    this.canTrig = CSS.supports('(top: calc(sin(1) * 1px))');
    this.options = {
      spacing: 2,
      text: this.string,
    }
  }

  get string() {
    let string = this.dataset.text;
    string = string.replace(/  +/g, ' ');
    return '•' + string.replace(/ +/g, '•')
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: -200
    });
  }

  init() {
    const PARAGRAPH = document.createElement('div');
    const chars = this.options.text.split('');

    // Take the text and split it into spans...
    PARAGRAPH.innerHTML += `<span class="visually-hidden">${this.options.text}</span>`;
    for (let [index, char] of chars.entries()) {
      PARAGRAPH.innerHTML += `<span aria-hidden="true" class="split-char d-inline-block p-absolute top-50 left-50" style="--char-index: ${index};">${char}</span>`
    }
    PARAGRAPH.classList = 'split-chars';

    // Set the styles
    this.style.setProperty('--char-count', chars.length);
    this.style.setProperty('--char-width', this.options.spacing);
    this.style.setProperty('--inner-angle', 'calc((360 / var(--char-count)) * 1deg)');
    this.style.setProperty('--radius', this.canTrig ? 'calc((var(--char-width) / sin(var(--inner-angle))) * -1ch' : `calc((${this.options.spacing} / ${Math.sin(360 / this.children.length / (180 / Math.PI))}) * -1ch)`);

    // Append
    this.appendChild(PARAGRAPH);
  }
}
customElements.define('spinning-text', SpinningText);

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
      if (drawer) drawer.open(button);
    });
  }
}

customElements.define('side-drawer-opener', SideDrawerOpener);

class ThemeAnimate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('loaded', true);
  }
}

customElements.define('theme-animate', ThemeAnimate);

class ThemeCollapse extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 400
    });
  }

  get breakpoint() {
    return this.dataset.breakpoint
  }

  get details() {
    return this.querySelector('details')
  }

  get summary() {
    return this.querySelector('summary')
  }

  init() {
    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.toggle.bind(this));
    this.checkBreakpoint();
    window.addEventListener('resize', this.checkBreakpoint.bind(this));
  }

  checkBreakpoint() {
    if(this.breakpoint == 'all' || this.breakpoint == undefined) return;
    if (!window.matchMedia(convertBreakpoint(this.breakpoint)).matches) {
      this.details.setAttribute('open', true);
    } else if (this.dataset.open == undefined){
      this.details.removeAttribute('open');
    }
  }

  toggle(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    this.details.removeAttribute('open');
  }
}

customElements.define('theme-collapse', ThemeCollapse);

class ThemeFancybox extends HTMLElement {
  constructor() {
    super();

    this.initFancybox();
  }

  initFancybox() {
    Fancybox.bind(this, '[data-fancybox]', {
      Thumbs : {
        type: "classic"
      },
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [
            "zoomIn",
            "toggle1to1",
            "zoomOut",
          ],
          right: ["slideshow", "thumbs", "close"],
        },
      }
    });
  }
}

customElements.define('theme-fancybox', ThemeFancybox);

class ThemeFilter extends HTMLElement {
  constructor() {
    super();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  all(button) {
    const _target = button.closest('li');
    if (_target.classList.contains('active')) return;
    const _current = this.querySelector(`li.active`);
    _current?.classList.remove('active');
    _target.classList.add('active');
    Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
  }

  active(button, code) {
    const _target = button.closest('li');
    if (_target.classList.contains('active')) return;
    const _current = this.querySelector(`li.active`);
    const items = this.querySelectorAll(`[data-filter=${code}]`);
    _current?.classList.remove('active');
    _target.classList.add('active');
    Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
    Array.from(items).forEach((item) => item.classList.remove('hidden'));
  }
}

customElements.define('theme-filter', ThemeFilter);

class ThemeGesturer extends HTMLElement {
  constructor() {
    super();

    this.config = {
      thresholdY: Math.max(25, Math.floor(0.15 * window.innerHeight)),
      velocityThreshold: 10,
      disregardVelocityThresholdY: Math.floor(0.5 * this.clientHeight),
      pressThreshold: 8,
      diagonalSwipes: false,
      diagonalLimit: Math.tan(((45 * 1.5) / 180) * Math.PI),
      longPressTime: 500,
    };

    this.handlers = {
      panstart: [],
      panmove: [],
      panend: [],
      swipeup: [],
      swipedown: [],
      longpress: [],
    };

    this.addEventListener('touchstart', this.onTouchStart.bind(this), ThemeSupportsPassive ? { passive: true } : false);
    this.addEventListener('touchmove', this.onTouchMove.bind(this), ThemeSupportsPassive ? { passive: true } : false);
    this.addEventListener('touchend', this.onTouchEnd.bind(this), ThemeSupportsPassive ? { passive: true } : false);
  }

  on(type, fn) {
    if (this.handlers[type]) {
      this.handlers[type].push(fn);
      return {
        type,
        fn,
        cancel: () => this.off(type, fn),
      };
    }
  }

  off(type, fn) {
    if (this.handlers[type]) {
      const idx = this.handlers[type].indexOf(fn);
      if (idx !== -1) this.handlers[type].splice(idx, 1);
    }
  }

  fire(type, event) {
    for (let i = 0; i < this.handlers[type].length; i++) {
      this.handlers[type][i](event);
    }
  }

  onTouchStart(event) {
    this.thresholdY = this.config.thresholdY;
    this.disregardVelocityThresholdY = this.config.disregardVelocityThresholdY;
    this.touchStartY = event.changedTouches[0].screenY;
    this.touchMoveY = null;
    this.touchEndY = null;
    this.swipingDirection = null;

    // Long press.
    this.longPressTimer = setTimeout(() => this.fire('longpress', event), this.config.longPressTime);
    this.fire('panstart', event);
  }

  onTouchMove(event) {
    const touchMoveY = event.changedTouches[0].screenY - (this.touchStartY ?? 0);
    this.velocityY = touchMoveY - (this.touchMoveY ?? 0);
    this.touchMoveY = touchMoveY;
    const absTouchMoveY = Math.abs(this.touchMoveY);
    this.swipingVertical = absTouchMoveY > this.thresholdY;
    this.swipingDirection = this.swipingVertical ? 'vertical' : 'pre-vertical';

    if (absTouchMoveY > this.config.pressThreshold) clearTimeout(this.longPressTimer ?? undefined);
    this.fire('panmove', event);
  }

  onTouchEnd(event) {
    this.touchEndY = event.changedTouches[0].screenY;
    this.fire('panend', event);
    clearTimeout(this.longPressTimer ?? undefined);

    const y = this.touchEndY - (this.touchStartY ?? 0);
    const absY = Math.abs(y);

    if (absY > this.thresholdY) {
      this.swipedVertical = this.config.diagonalSwipes ? y <= this.config.diagonalLimit : absY > this.thresholdY;
      if (this.swipedVertical) {
        if (y < 0) {
          // Upward swipe.
          if ((this.velocityY ?? 0) < -this.config.velocityThreshold || y < -this.disregardVelocityThresholdY) this.fire('swipeup', event);
        } else {
          // Downward swipe.
          if ((this.velocityY ?? 0) > this.config.velocityThreshold || y > this.disregardVelocityThresholdY) this.fire('swipedown', event);
        }
      }
    }
  }
}

customElements.define('theme-gesturer', ThemeGesturer);

class ThemeMarquee extends HTMLElement {
  constructor() {
    super();

    this.spaceBetween = 100;
    this.speed = parseFloat(this.dataset.speed);
    this.list = this.querySelector('.marquee__list');
    this.elements = this.querySelectorAll('.marquee__items');
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: -200
    });
  }

  init() {
    if(this.elements.length === 1) {
      this.elements[0].classList.add('marquee__items--animated');
      this.elements[0].setAttribute('data-index', 1);

      for (let i = 0; i < 9; i++) {
        this.clone = this.elements[0].cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.clone.setAttribute('data-index', i + 2);
        this.list.appendChild(this.clone);
      }

      const animationTimeFrame = (this.elements[0].clientWidth / this.spaceBetween) * this.speed;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);
    }

    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.list.classList.remove('marquee__list-paused');
        } else {
          this.list.classList.add('marquee__list-paused');
        }
      });
    }, {rootMargin: '0px 0px 50px 0px'});

    observer.observe(this);
  }
}

customElements.define('theme-marquee', ThemeMarquee);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.getOffsetTop(this)) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define('animate-sticky', AnimateSticky);

class ThemeMasonry extends HTMLElement {
  constructor() {
    super();
    this.Shuffle = window.Shuffle;
    this.container = this.querySelector('.shuffle-container');
    this.sizer = this.querySelector('.sizer-element');
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.shuffleInstance = new this.Shuffle(this.container, {
      itemSelector: '.shuffle-element',
      sizer: this.sizer
    });
  }
}

customElements.define('theme-masonry', ThemeMasonry);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.swiper');
    this.pagination = this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prev = this.querySelector('.swiper-button-prev');
    this.next = this.querySelector('.swiper-button-next');
    this.play = this.querySelector('.swiper-button-play');
    this.pause = this.querySelector('.swiper-button-pause');
    this.count = this.querySelector('[data-swiper-count]')
    this.videos = this.querySelectorAll('iframe, video');
    this.threshold = -200;
    this.spacing = this.getAttribute('data-spacing') === 'true' ? true : false;
    this.effect = this.getAttribute('data-effect');

    this.defaultSettings = this.dataset.swiper || {};
    if (Object.keys(this.defaultSettings).length != 0) this.defaultOptions = JSON.parse(this.defaultSettings);

    this.options = Object.assign({}, this.defaultOptions);
    this.options = {
      ...this.options,
      pagination: {
        el: this.pagination,
        clickable: true
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          if(this.spacing) {
            element.isLocked ? this.classList.add('theme-swiper--locked') : this.classList.add('theme-swiper--not-locked');
          }
          
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        }
      }
    }
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: this.threshold
      });
    } else {
      this.init();
    }
  }

  init() {
    this.swiper = new Swiper(this.slider, this.options);

    this.swiper.on('resize', () => {
      if(this.spacing) {
        if(this.swiper.isLocked) {
          this.classList.add('theme-swiper--locked');
          this.classList.remove('theme-swiper--not-locked')
        } else{
          this.classList.remove('theme-swiper--locked');
          this.classList.add('theme-swiper--not-locked');
        }
      }
    });

    this.swiper.on('init', () => {
      console.log(this.swiper);
    });

    this.swiper.on('update', () => {
      if(this.spacing) {
        if(this.swiper.isLocked) {
          this.classList.add('theme-swiper--locked');
          this.classList.remove('theme-swiper--not-locked')
        } else{
          this.classList.remove('theme-swiper--locked');
          this.classList.add('theme-swiper--not-locked');
        }
      }
    });

    this.swiper.on('transitionStart', () => {
      Array.prototype.forEach.call(this.videos, (video) => {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          var iframeSrc = video.src;
            video.src = iframeSrc;
        }
      });
    });

    this.swiper.on('transitionEnd', () => {
      var activeSlide = this.getElementsByClassName('swiper-slide')[this.swiper.activeIndex];
      var activeSlideVideos = activeSlide.querySelectorAll('iframe, video');
      Array.prototype.forEach.call(activeSlideVideos, (video) => {
        if (video.tagName.toLowerCase() === "video"){
          video.play();
          if(this.swiper.autoplay.running == true) {
            this.play?.classList.remove('hidden');
            this.pause?.classList.add('hidden');
            this.swiper.autoplay.stop();
            this.classList.add('theme-swiper--paused');
          }
        }
      });
    });

    this.swiper.on('slideChange', () => {
      this.swiper.pagination.render();
      this.swiper.pagination.update();
      this.swiper.navigation.destroy();
      this.swiper.navigation.init();
    });

    this.swiper.on('slideChangeTransitionStart', () => {
      this.count && this.setActiveSlideItemIndex();
    });

    this.swiper.on('slideChangeTransitionEnd', () => {});
    Array.prototype.forEach.call(this.videos, (video) => {
      if (video.tagName.toLowerCase() === "video") {
        video.addEventListener('play', () => this.pauseSlider());
        video.addEventListener('pause', () => this.playSlider());
      }
    });
    this.play?.addEventListener('click', this.playSlider.bind(this));
    this.pause?.addEventListener('click', this.pauseSlider.bind(this));
  }

  setActiveSlideItem(activeIndex) {
    this.swiper.slideTo(activeIndex);
  }

  setActiveSlideItemIndex() {
    this.count.innerHTML = this.swiper.activeIndex < 9 ? `0${this.swiper.activeIndex + 1}` : this.swiper.activeIndex + 1;
  }

  playSlider() {
    this.play?.classList.add('hidden');
    this.pause?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = this.autoplayDelayTime;
    this.swiper.autoplay.start();
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider() {
    this.pause?.classList.add('hidden');
    this.play?.classList.remove('hidden');
    this.swiper.autoplay.stop();
    this.classList.add('theme-swiper--paused');
  }

  updateVideos() {
    this.videos = this.querySelectorAll('iframe, video');
    Array.prototype.forEach.call(this.videos, (video) => {
      if (video.tagName.toLowerCase() === "video") {
        video.addEventListener('play', () => this.pauseSlider());
        video.addEventListener('pause', () => this.playSlider());
      }
    });
  }
}

customElements.define('theme-swiper', ThemeSwiper);

class ThemeSwiperPoint extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onClickButton.bind(this));
  }

  onClickButton() {
    const swiper = document.querySelector(this.dataset.swiper);
    const activeItem = document.querySelector(this.dataset.slide);
    if (!swiper || !activeItem) return;
    swiper.setActiveSlideItem(activeItem.dataset.index);
  }
}

customElements.define('theme-swiper-point', ThemeSwiperPoint);

class ThemeTab extends HTMLElement {
  constructor() {
    super();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  filtering(value) {
    if(value == 'all') {
      Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
    } else {
      const items = this.querySelectorAll(`[data-filter=${value}]`);
      Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
      Array.from(items).forEach((item, index) => {
        item.classList.remove('hidden')
        if(index == 0) {
          item.querySelector('button')?.click();
        }
      });
    }
  }

  open(button, tab) {
    const _target = button.closest('li');
    if (_target.classList.contains('active')) return;
    const _active = this.querySelector(`li.active`);
    const _activeTab = this.querySelector(`.tab__content-item.active`);
    const _targetTab = this.querySelector(`[data-tab-id="${tab}"]`);
    _active.classList.remove('active');
    _activeTab.classList.remove('active');
    _target.classList.add('active');
    _targetTab.classList.add('active');
    this.load(_targetTab);
  }

  load(tab) {
    if (!tab.getAttribute('loaded')) {
      const content = tab.querySelector('template').content.cloneNode(true);

      tab.appendChild(content);
      tab.setAttribute('loaded', true);
    }
  }
}

customElements.define('theme-tab', ThemeTab);

class ThemeToggle extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onClickButton.bind(this));
  }

  onClickButton() {
    const _targets = Array.from(document.querySelectorAll(this.dataset.target));
    const _classes = this.dataset.toggleClass.split(' ');
    this.toggleClass(_targets, _classes);
  }

  toggleClass(elements, classes, check) {
    switch (check) {
      case true:
        elements.forEach((element) => element.classList.add(...classes));
        break;
      case false:
        elements.forEach((element) => element.classList.remove(...classes));
        break;
      default:
        elements.forEach((element) => element.classList.toggle(...classes));
        break;
    }
  }
}

customElements.define('theme-toggle', ThemeToggle);

class TrackingViewedProducts extends HTMLElement {
  constructor() {
    super();

    this.record({ name: 'shopify_recently_viewed_products', expire: '30', max: 10 });
  }

  readCookie (name) {
    let list = [],
    data = getCookie(name);

    if (data !== null && data !== undefined && data !== '') list = data.split(' ');
    return list;
  }

  setCookie(params, list) {
    if (this.dataset.productId !== '') {
      let productId = this.dataset.productId,
        position = list.indexOf(productId);

      if (position === -1) {
        list.unshift(productId);
        list = list.splice(0, params.max);
      } else {
        list.splice(position, 1);
        list.unshift(productId);
      }
      this.writeCookie(params.name, params.expire, list);
    }
  }

  writeCookie(name, day, list) {
    setCookie(name, list.join(' '), { expires: day, path: '/', domain: window.location.hostname });
  }

  destroyCookie (name, day) {
    setCookie(name, null, { expires: day, path: '/', domain: window.location.hostname });
  }

  record(params) {    
    this.setCookie(params, this.readCookie(params.name));
  }
}

customElements.define('tracking-viewed-products', TrackingViewedProducts);

class VideoTemplate extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('iframe');
    this.isMouseenter = false;
  }

  loadVideo() {
    if(!this.video) return;

    this.dispatchEvent(new CustomEvent('loadingStart', { detail: { element: this.video, parent: this }}));
    this.video.setAttribute('src', this.video.getAttribute('data-src'));
    this.video.addEventListener('load', function() {
      this.dispatchEvent(new CustomEvent('loadingEnd', { detail: { element: this.video, parent: this }}));
      this.dataVideoType == 'youtube' && this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
    }.bind(this));

    this.isLoaded(true);
  }

  init() {
    if(this.dataset.autoplay === 'true') {
      if(Shopify.designMode){
        this.loadVideo();
      } else {
        ['mouseenter', 'touchstart'].forEach(function(e) {
          document.body.addEventListener(e, function() {
            this.isMouseenter || this.loadVideo();
            this.isMouseenter = true;
          }.bind(this));
        }.bind(this));

        window.addEventListener('scroll', function() {
          this.isMouseenter || this.loadVideo();
          this.isMouseenter = true;
        }.bind(this), false);
      }
    } else {
      this.isMouseenter = true;
    }
  }

  isLoaded(load) {
    if(load) {
      this.setAttribute('loaded', true);
      this.querySelectorAll('img, svg').forEach(element => element.remove());
    } else {
      this.removeAttribute('loaded');
    }
  }

  static get observedAttributes() {
    return ['data-video-type', 'data-video-id']
  }

  set dataVideoType(type) {
    this.setAttribute('data-video-type', type);
  }

  get dataVideoType() {
    return this.getAttribute('data-video-type')
  }

  set dataVideoId(id) {
    this.setAttribute('data-video-id', id);
  }

  get dataVideoId() {
    return this.getAttribute('data-video-id')
  }

  attributeChangedCallback(name, oldValue, newValue) {
    oldValue !== newValue && this.init();
  }

  connectedCallback() {
    this.init();
  }
}

customElements.define('video-template', VideoTemplate);

class VideoTemplateOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const video = document.querySelector(this.getAttribute('data-video'));
      if (video) video.loadVideo();
      this.classList.add('hidden');
    });
  }
}

customElements.define('video-template-opener', VideoTemplateOpener);